<template>
  <div>
    <ul
      v-if="blogList.list.length > 0"
      class="column_list"
      :class="[classType]"
    >
      <!-- card_ty1(compay + title), card_ty2(compay + title + txt), card_ty3(img+ title + compay), card_ty4(compay + title + txt + tag + img) -->
      <li
        v-for="item in blogList.list"
        :key="item.postSeq"
      >
        <div class="column_list_item">
          <div class="text_box">
            <div class="link_company">
              <a href="#">
                <span class="logo">
                  <span />
                  <!--                <img src="../../../assets/images/temp/img_large.jpg" alt="">-->
                </span>
                <span class="name font_p3">{{ item.companyName }}</span>
                <span class="date font_p3">{{ convertDateFormat(item.creDt) }}</span>
              </a>
              <button-bookmark
                :id="item.postSeq"
                :bookmark-yn="item.likeYn"
              />
              <button
                v-if="
                  businessProfile.businessSeq === searchParam.businessSeq &&
                  searchParam.categoryNo === 243672 &&
                  businessProfile.useMediaPublish === 'Y' &&
                  !item.publishStatus
                "
                type="button"
                class="btn_publish"
                @click.prevent="navigateToMediaPublish(item.postSeq)"
              >
                배포요청
              </button>
              <span
                v-if="
                  businessProfile.businessSeq === searchParam.businessSeq &&
                  searchParam.categoryNo === 243672 &&
                  businessProfile.useMediaPublish === 'Y' &&
                  item.publishStatus
                "
                :class="publishButtonStyle(item.publishStatus)"
              >
                <span>{{ publishLabel(item.publishStatus) }}</span>
              </span>
              <button
                type="button"
                class="btn_write"
                @click.prevent="navigateToContentsUpdate(item.postSeq)"
              >
                <i class="icon_font_write icon_size_24" /><span class="blind">글쓰기</span>
              </button>
            </div>
            <a
              href="#"
              class="link_text"
              @click.prevent="
                navigateToPostWithAnalysis(item.postSeq, {
                  query: { writer: item.companyName, affect_type: AFFECT_TYPE.CORP_PROFILE }
                })
              "
            >
              <span class="title font_h6">{{ item.title }}</span>
              <span class="txt font_p2"> {{ category }}ㆍ{{ item.interestName }}</span>
            </a>
            <ul class="tag_list">
              <li
                v-for="(tag, i) in convertCommaToList(item.tags)"
                :key="`${tag}_${i}`"
              >
                <a href="#">#{{ tag }}</a>
              </li>
            </ul>
          </div>
          <a
            href="#"
            class="link_img"
            @click.prevent="
              navigateToPostWithAnalysis(item.postSeq, {
                query: { writer: item.companyName, affect_type: AFFECT_TYPE.CORP_PROFILE }
              })
            "
          >
            <span
              ><img
                :src="thumbnailImageWithOptions(item.thumbnailImageId, { w: 180 })"
                alt=""
            /></span>
          </a>
        </div>
      </li>
    </ul>
    <p
      v-else
      class="text_none font_p2 mt60 m_mt36"
    >
      콘텐츠가 없습니다.
    </p>
    <list-infinity-scroll
      ref="infinityScrollRef"
      :more="handleListMore"
    />
  </div>
</template>
<script setup lang="ts">
import { DateUtil } from "@tms/utils";
import type { PayloadDateFormat } from "@tms/utils/dist/src/date/types";

import { SigninAuth } from "@tms/authorization";
import { convertCommaToList } from "~/utils/convert";
import route from "~/config/route";
import type { IBlog, IBlogListParameter } from "~/modules/business/types/business";
import BusinessService from "~/modules/business/services/business";
import { useImagesThumbnail } from "~/composables/images/thumbnail";
import useContentNavigator from "~/modules/content/composables/navigate";
import { AFFECT_TYPE } from "~/modules/content/types/type";

const auth = new SigninAuth();

const { classType } = defineProps<{ classType: string }>();
const businessService = new BusinessService();
const { thumbnailImageWithOptions } = useImagesThumbnail();
const { navigateToPostWithAnalysis } = useContentNavigator();

const blogList = reactive<{ list: IBlog[] }>({ list: [] });
const publishLabel = (status: string) => {
  if (status === "WAITING") {
    return "배포대기중";
  } else if (status === "PUBLISHED") {
    return "배포완료";
  } else {
    return "";
  }
};

const publishButtonStyle = (status: string) => {
  if (status === "WAITING") {
    return "btn_publish btn_publish_waiting";
  } else if (status === "PUBLISHED") {
    return "btn_publish btn_publish_completed";
  } else {
    return "btn_publish_canceled";
  }
};

const searchParam = reactive<IBlogListParameter>({
  categoryNo: 0,
  whereType: "FINISH",
  currentPage: 0,
  cntPerPage: 10,
  businessSeq: 0
});
const apiUrl = ref("");
const infinityScrollRef = ref<any>(null);
const category = ref("");
const businessProfile = ref<any>({ useMediaPublish: "N" });

/**
 * @description 블로그 리스트 조회
 * @param categoryNo
 * @param categoryName
 * @param whereType
 * @param businessSeq
 * @param api
 * @param currentPage
 */
const getBlogList = async ({
  categoryNo,
  categoryName,
  api,
  whereType,
  businessSeq,
  currentPage
}: {
  categoryNo: number;
  categoryName: string;
  api: string;
  whereType?: string;
  businessSeq?: number;
  currentPage?: number;
}) => {
  if (searchParam.categoryNo !== categoryNo || searchParam.whereType !== whereType) {
    searchParam.currentPage = 0;
    blogList.list = [];
  }
  apiUrl.value = api;
  category.value = categoryName;
  searchParam.categoryNo = categoryNo;
  searchParam.whereType = whereType;
  searchParam.businessSeq = businessSeq;
  searchParam.currentPage = (currentPage ?? 0) + 1;
  const list = await businessService.getBlogList(searchParam, api);

  if (searchParam.currentPage === 1) {
    blogList.list = list.list;
    infinityScrollRef.value && infinityScrollRef.value.init();
  } else {
    blogList.list.push(...list.list);
  }

  if (blogList.list.length >= list.totalCnt) {
    infinityScrollRef.value && infinityScrollRef.value.setEnded(true);
  }
};

const getBusinessProfile = async () => {
  if (await auth.isSignin()) {
    const response = (await businessService.getMyBusinessProfile()).business;
    if (response) {
      businessProfile.value = response;
    }
  }
};

const handleListMore = async () => {
  await getBlogList({
    categoryNo: searchParam.categoryNo,
    categoryName: category.value,
    api: apiUrl.value,
    whereType: searchParam.whereType,
    businessSeq: searchParam.businessSeq,
    currentPage: searchParam.currentPage
  });
};

/**
 * @description 날짜 포맷 변경
 * @param date
 */
const convertDateFormat = (date: number) => {
  const format: PayloadDateFormat = {
    date: date * 1000,
    format: "yyyy.MM.dd"
  };
  return DateUtil.convertDateFormat(format);
};

/**
 * @description 글쓰기 페이지로 이동
 */
const navigateToContentsUpdate = (seq: number) => {
  navigateTo(`${route.MY_PAGE_BUSINESS_CONTENTS}?id=${seq}`);
};

const navigateToMediaPublish = (seq: number) => {
  navigateTo(`/mypage/media-publish/register?postSeq=${seq}`);
};

const convertImg = (imgId: string) => {
  return thumbnailImageWithOptions(imgId, { w: 180 });
};

getBusinessProfile();

defineExpose({
  getBlogList
});
</script>
<style scoped>
.column_list.card_ty3 {
  display: flex;
  flex-direction: stretch;
  flex-wrap: wrap;
  justify-content: space-between;
  align-content: space-around;
  gap: 24px;
}

.column_list.card_ty3 .column_list_item {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.column_list.card_ty3 > li {
  padding: 0;
  border: none;
  width: calc(50% - 12px);
  position: relative;
}

.column_list.card_ty3 > li:last-child {
  margin-bottom: 0;
}

.column_list.card_ty3 .link_img {
  display: block;
  width: 180px;
  height: 102px;
  position: absolute;
  left: 0;
  top: 0;
}

.column_list.card_ty3 > li:first-child .link_img {
  top: 0;
}

.column_list.card_ty3 .column_list_item {
  padding-left: 204px;
  min-height: 104px;
}

.column_list.card_ty3 .text_box {
  width: calc(100%);
  padding: 0 0 40px 0;
}

.column_list.card_ty3 .link_company {
  position: absolute;
  right: 0;
  width: 100%;
  bottom: 0;
}

.column_list.card_ty3 .link_company + .link_text {
  margin: 0;
}

.column_list.card_ty4 .column_list_item {
  display: flex;
  justify-content: space-between;
}

.column_list.card_ty4 > li {
  margin-bottom: 36px;
  padding: 0;
  border: none;
}

.column_list.card_ty4 > li:last-child {
  margin-bottom: 0;
}

.column_list.card_ty4 .link_img {
  display: block;
}

.column_list.card_ty4 .text_box {
  width: calc(100% - 306px);
  padding-top: 5px;
}

.column_list.card_ty4 .tag_list {
  display: block;
}

.column_list.card_ty5 .column_list_item {
  display: flex;
  justify-content: space-between;
}

.column_list.card_ty5 > li {
  padding: 24px 0;
}

.column_list.card_ty5 .link_img {
  display: block;
  width: 180px;
  height: 102px;
}

.column_list.card_ty5 .text_box {
  width: calc(100% - 204px);
}

.column_list.card_ty5 .tag_list {
  display: block;
}

.column_list.card_ty6 .column_list_item {
  display: flex;
  justify-content: space-between;
}

.column_list.card_ty6 > li {
  padding: 24px 0;
}

.column_list.card_ty6 .link_img {
  display: block;
  width: 180px;
  height: 102px;
}

.column_list.card_ty6 .text_box {
  width: calc(100% - 204px);
}

.column_list.card_ty6 .tag_list {
  display: block;
}

.column_list.card_ty6 .link_company .name,
.column_list.card_ty6 .link_company .logo,
.column_list.card_ty6 .link_company .date:before {
  display: none;
}

.column_list.card_ty6 .link_company + .link_text {
  margin-top: 6px;
}

.column_list.card_ty7 .column_list_item {
  display: flex;
  justify-content: space-between;
}

.column_list.card_ty7 > li {
  padding: 24px 0;
}

.column_list.card_ty7 .link_img {
  display: block;
  width: 180px;
  height: 102px;
}

.column_list.card_ty7 .text_box {
  width: calc(100% - 204px);
}

.column_list.card_ty7 .link_company .name,
.column_list.card_ty7 .link_company .logo,
.column_list.card_ty7 .link_company .date:before {
  display: none;
}

.column_list.card_ty7 .link_company + .link_text {
  margin-top: 6px;
}

.column_list.card_ty7 .tag_list {
  display: block;
}

.column_list.card_ty7 .link_text + .tag_list {
  margin-top: 8px;
}

.column_ty3 .column_list_item {
  min-height: 108px;
}

.column_list > li {
  padding: 16px 0;
  border-bottom: 1px solid var(--color-line);
}

.column_list .text_box {
  position: relative;
}

.column_list .link_img {
  display: none;
  position: relative;
  width: 282px;
  height: 160px;
  overflow: hidden;
  border-radius: 8px;
}

.column_list .link_img img {
  position: absolute;
  top: -100%;
  right: -100%;
  bottom: -100%;
  left: -100%;
  width: 100%;
  height: 100%;
  object-fit: cover;
  margin: auto;
}

.column_list .link_company + .link_text {
  margin-top: 8px;
}

.column_list .link_text + .tag_list {
  margin-top: 20px;
}

.column_list .tag_list {
  display: none;
  height: 22px;
  overflow: hidden;
}

.column_list .tag_list li {
  display: inline-block;
  margin: 0 8px 0 0;
}

.column_list .tag_list li a {
  display: inline-block;
  padding: 0 8px;
  line-height: 1.375rem;
  font-size: var(--font-size-8);
  color: var(--color-text-sub);
  background: var(--color-background-sub1);
  box-sizing: border-box;
  border-radius: 4px;
}

.column_list .tag_list li:last-child {
  margin: 0;
}

.link_company {
  position: relative;
}

.link_company a {
  display: flex;
  align-items: center;
  gap: 5px;
  width: fit-content;
}

.link_company .logo {
  position: relative;
  display: inline-block;
  width: 24px;
  height: 24px;
  border-radius: 100%;
  overflow: hidden;
}

.link_company .logo span {
  display: inline-block;
  width: 24px;
  height: 24px;
  background: #fff;
  border: 1px solid var(--color-line);
  border-radius: 100%;
  box-sizing: border-box;
}

.link_company .logo img {
  position: absolute;
  top: -100%;
  right: -100%;
  bottom: -100%;
  left: -100%;
  width: auto;
  height: 100%;
  margin: auto;
}

.link_company .name {
  color: var(--color-text-title);
  letter-spacing: 0;
}

.link_company .date {
  display: flex;
  align-items: center;
  gap: 5px;
  letter-spacing: 0;
}

.link_company .date:before {
  content: "";
  display: inline-block;
  width: 2px;
  height: 2px;
  background: var(--color-text-sub);
  border-radius: 100%;
}

.column_list.card_ty7 .link_company .date {
  font-size: var(--font-size-7);
}

.link_company .check_bookmark {
  position: absolute;
  right: 0;
  top: 0;
  width: 24px;
}

.link_company .btn_write {
  position: absolute;
  right: 0;
  top: 0;
  width: 24px;
}

.link_company .btn_publish {
  position: absolute;
  right: 0;
  top: 0;
  margin-right: 40px;
  line-height: 20px;
  border-radius: 5px;
  border: 1px solid #ffd5d5;
  background-color: #fff1f1;
  padding: 0 5px;
  font-size: 9px;
  font-weight: bold;
}

.link_company .btn_publish_waiting {
  color: #7e7e7e;
  border-radius: 5;
  border: 0px solid #9bb2dd;
  background-color: #cee1f3;
}

.link_company .btn_publish_completed {
  color: #a3a3a3;
  border-radius: 5;
  border: 0px solid #559e5c;
  background-color: #b0edb9;
}

.link_company .btn_publish_canceled {
  color: #a3a3a3;
  border-radius: 5;
  border: 0px solid #7e7e7e;
  background-color: #c3c3c3;
}


.column_list.card_ty1 .check_bookmark {
  display: none;
}

.column_list.card_ty1 .btn_write {
  display: none;
}

.column_list.card_ty6 .check_bookmark {
  display: none;
}

.column_list.card_ty7 .btn_write {
  display: none;
}

.column_list .link_text {
  display: block;
}

.column_list .link_text span {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  white-space: normal;
  word-break: break-all;
}

.column_list .link_text .title {
  color: var(--color-text-headline);
  -webkit-line-clamp: 2;
  line-height: 130%;
}

.column_list .link_text:hover .title {
  text-decoration: underline;
}

.column_list.card_ty1 .link_text .title {
  -webkit-line-clamp: 1;
}

.column_list.card_ty1 .link_text .txt {
  display: none;
}

.column_list.card_ty3 .link_text .txt {
  display: none;
}

.column_list.card_ty4 .link_text .title {
  font-size: var(--font-size-5);
}

.column_list.card_ty5 .link_text .title {
  font-size: var(--font-size-5);
}

.column_list.card_ty6 .link_text .txt {
  font-size: var(--font-size-7);
  margin-top: 8px;
}

.column_list.card_ty7 .link_text .txt {
  display: none;
}

.column_list_item.read .link_img:after {
  content: "";
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: var(--color-background-default);
  opacity: 0.6;
}

.column_list_item.read .link_text .title {
  color: var(--color-text-sub);
}

@media screen and (max-width: 768px) {
  .column_list.card_ty4 .link_text {
    min-height: 42px;
  }

  .column_list.card_ty4 .link_text .txt {
    display: none;
  }

  .column_list.card_ty5 .link_text .txt {
    display: none;
  }
}

@media screen and (max-width: 1400px) {
  .column_list.card_ty3 {
    flex-direction: column;
  }

  .column_list.card_ty3 > li {
    width: calc(100%);
  }

  .column_list.card_ty3 .column_list_item {
    min-height: auto;
  }
}

@media screen and (max-width: 768px) {
  .column_list.card_ty2 .tag_list {
    display: block;
  }

  .column_list.card_ty3 {
    gap: 0;
  }

  .column_list.card_ty3 > li {
    margin-bottom: 0;
    padding: 16px 0;
    border-bottom: 1px solid var(--color-line);
  }

  .column_list.card_ty3 > li:first-child {
    padding-top: 0;
  }

  .column_list.card_ty3 .column_list_item {
    padding-left: 100px;
    min-height: 88px;
  }

  .column_list.card_ty3 .text_box {
    padding: 0 0 36px 0;
  }

  .column_list.card_ty3 .link_img {
    width: 88px;
    height: 88px;
  }

  .column_list.card_ty4 > li {
    margin-bottom: 0;
    padding: 16px 0;
    border-bottom: 1px solid var(--color-line);
  }

  .column_list.card_ty4 > li:first-child {
    padding-top: 0;
  }

  .column_list.card_ty4 .text_box {
    width: calc(100% - 100px);
    padding: 0;
  }

  .column_list.card_ty4 .link_company {
    width: calc(100% + 100px);
  }

  .column_list.card_ty4 .link_img {
    margin-top: 32px;
  }

  .column_list.card_ty4 .link_text {
    min-height: 42px;
  }

  .column_list.card_ty4 .link_text .txt {
    display: none;
  }

  .column_list.card_ty5 > li {
    padding: 16px 0;
  }

  .column_list.card_ty5 > li:first-child {
    padding-top: 20px;
  }

  .column_list.card_ty5 .text_box {
    width: calc(100% - 100px);
  }

  .column_list.card_ty5 .link_company {
    width: calc(100% + 100px);
  }

  .column_list.card_ty5 .link_img {
    width: 88px;
    height: 88px;
    margin-top: 32px;
  }

  .column_list.card_ty5 .link_text .txt {
    display: none;
  }

  .column_list.card_ty6 > li {
    padding: 16px 0;
  }

  .column_list.card_ty6 > li:first-child {
    padding-top: 20px;
  }

  .column_list.card_ty6 .text_box {
    width: calc(100% - 100px);
  }

  .column_list.card_ty6 .link_company {
    width: calc(100% + 100px);
  }

  .column_list.card_ty6 .link_img {
    width: 88px;
    height: 88px;
    margin-top: 32px;
  }

  .column_list.card_ty6 .link_text .txt {
    margin-top: 24px;
  }

  .column_list.card_ty6 .link_company + .link_text {
    margin-top: 10px;
  }

  .column_list.card_ty7 > li {
    padding: 16px 0;
  }

  .column_list.card_ty7 > li:first-child {
    padding-top: 20px;
  }

  .column_list.card_ty7 .text_box {
    width: calc(100% - 100px);
  }

  .column_list.card_ty7 .link_company {
    width: calc(100% + 100px);
  }

  .column_list.card_ty7 .link_img {
    width: 88px;
    height: 88px;
    margin-top: 32px;
  }

  .column_list.card_ty7 .link_company + .link_text {
    margin-top: 10px;
  }

  .column_list.card_ty7 .link_text + .tag_list {
    margin-top: 26px;
  }

  .column_list .link_img {
    width: 88px;
    height: 88px;
  }

  .column_list .link_text + .tag_list {
    margin-top: 24px;
  }
}
</style>
